import { Routes } from '@angular/router';
import { AuthGuard } from './authentication/auth.guard';
import { AppBlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';


export const AppRoutes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        component: FullComponent,
        children: [
            {
                path: '',
                redirectTo: '/authentication/login',
                pathMatch: 'full'
            },
            {
                path: 'property',
                loadChildren: () => import('./property/property.module').then(x => x.PropertyModule),
                data: { rState: 0 }
            },
            // {
            //     path: 'news',
            //     loadChildren: () => import('./news/news.module').then(x => x.NewsModule),
            //     data: { rState: 0 }
            // },
            {
                path: 'todo',
                loadChildren: () => import('./todo/todo.module').then(x => x.TodoModule),
                data: { rState: 0 }
            },
            {
                path: 'notifications',
                loadChildren: () => import('./notifications/notifications.module').then(x => x.NotificationsModule),
                data: { rState: 0 }
            },
            {
                path: 'business-insight',
                loadChildren: () => import('./business-insight/business-insight.module').then(x => x.BusinessInsightModule),
                data: { rState: 0 }
            },
            {
                path: 'service-request',
                loadChildren: () => import('./service-request/service-request.module').then(x => x.ServiceRequestModule),
                data: { rState: 0 }
            },
            {
                path: 'template',
                loadChildren: () => import('./listing-template/listing-template.module').then(x => x.ListingTemplateModule),
                data: { rState: 0 }
            },
            {
                path: "profile",
                loadChildren: () => import('./Profile/profile.module').then(x => x.ProfileModule),
                data: { rState: 0 }
            },
        ]
    },
    {
        path: '',
        component: AppBlankComponent,
        children: [
            {
                path: 'authentication',
                loadChildren: () => import('./authentication/authentication.module').then(x => x.AuthenticationModule),
                data: { rState: 0 }
            }
        ]
    },
    {
        path: 'leasetodo',
        redirectTo: 'authentication/login',
        data: { rState: 0 }
    },
    {
        path: '**',
        redirectTo: 'authentication/404',
        data: { rState: 0 }
    }
];
